<script setup lang="ts">
// 路由切换时的顶部加载进度条
// 使用 CSS 动画模拟进度增长，无需精确计算真实进度
</script>

<template>
  <div class="route-loading-bar">
    <div class="route-loading-bar-inner"></div>
  </div>
</template>

<style scoped>
.route-loading-bar {
  position: fixed;
  top: 56px; /* 紧贴 header 下方 */
  left: 0;
  right: 0;
  z-index: 9999;
  height: 3px;
  background: transparent;
  pointer-events: none;
}

.route-loading-bar-inner {
  height: 100%;
  background: linear-gradient(90deg, var(--td-brand-color-4), var(--td-brand-color), var(--td-brand-color-6));
  border-radius: 0 2px 2px 0;
  animation: routeLoadingProgress 1.2s ease-out forwards;
  box-shadow: 0 0 8px rgba(0, 82, 217, 0.5);
}

@keyframes routeLoadingProgress {
  0% {
    width: 0%;
    opacity: 1;
  }
  30% {
    width: 40%;
  }
  70% {
    width: 75%;
    opacity: 1;
  }
  100% {
    width: 95%;
    opacity: 0.8;
  }
}

/* 移动端进度条也紧贴顶部 */
@media (max-width: 800px) {
  .route-loading-bar {
    top: 56px;
  }
}
</style>
